<!-- 库房单元 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <div class="page_content_top_line">
                <el-form @submit.native.prevent :inline="true" ref="getRequestData" :model="getRequestData"
                    label-width="100px" :hide-required-asterisk="false" class="demo-form-inline dis" size="mini"
                    v-if="reportConditionVos.length > 0" :show-message="false">
                    <el-form-item :prop="formOneValue.fieldEntity"
                        :rules="[{ required: formOneValue.isReq == 1, trigger: ['blur', 'change'] }]" class="pd"
                        v-for="(formOneValue, formOneKey) in reportConditionVos" :key="formOneKey">
                        <label slot="label" :style="$common.labelStyle(formOneValue.fieldShow)"
                            v-html="$common.htmlLabel(formOneValue.fieldShow)"></label>
                        <el-input @input="$forceUpdate()" clearable class="form_codition"
                            v-if="formOneValue.fieldType == 'string'"
                            @change="((val) => { handleChange(val, formOneValue.fieldEntity) })"
                            :placeholder="'请输入' + formOneValue.fieldShow"
                            v-model.trim="getRequestData[formOneValue.fieldEntity]" size="mini">
                        </el-input>
                        <el-date-picker class="form_codition" v-else-if="formOneValue.fieldEntity == 'SRQ'" size="mini"
                            v-model="getRequestData[formOneValue.fieldEntity]"  format="yyyy 年 MM 月 dd 日"
                             value-format="timestamp"  type="date"  placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker class="form_codition" v-else-if="formOneValue.fieldEntity == 'ERQ'" size="mini"
                            @focus="timeFocus(formOneValue.fieldEntity)"
                            v-model="getRequestData[formOneValue.fieldEntity]"  format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp"  type="date"  placeholder="选择日期">
                        </el-date-picker>

                        <el-input class="form_codition" clearable v-else
                            v-model.trim="getRequestData[formOneValue.fieldEntity]"
                            @change="((val) => { handleChange(val, formOneValue.fieldEntity) })"
                            @input="$forceUpdate()">
                        </el-input>
                    </el-form-item>
                    <el-form-item class="pd">
                        <el-button type="primary" size="mini" icon="el-icon-search"
                            @click="getList('getRequestData')">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <v-tabs :type="60" :isSet="false" :activeName="activeName" :name="'0'" :tabslist="reportModuleVos"
            @tabs="handleClick" @openFormDesign="openFormDesign">
            <template slot="btn">
                <li>
                    <el-tooltip class="item" effect="dark" content="刷新" placement="top">
                        <i class="el-icon-refresh icons" @click="getPageInfo()"></i>
                    </el-tooltip>
                </li>
                <li>
                    <el-tooltip class="item" effect="dark" content="汇总" placement="top">
                        <i class="el-icon-s-data icons" @click="recordSummary"></i>
                    </el-tooltip>
                </li>
                <li>
                    <el-tooltip class="item" effect="dark" content="过滤" placement="top">
                        <i class="el-icon-edit-outline icons" @click="recordFiltering"></i>
                    </el-tooltip>
                </li>
                <!-- <li v-if="opmExport == 1">
                    <el-tooltip class="item" effect="dark" content="导出" placement="top">
                        <i class="el-icon-download icons" @click="exportData"></i>
                    </el-tooltip>
                </li>
                <li v-if="isZjReport">
                    <el-tooltip class="item" effect="dark" content="质检报告" placement="top">
                        <i class="el-icon-document icons" @click="lookZjReport"></i>
                    </el-tooltip>
                </li>
                <li v-if="isPrint == 1">
                    <el-tooltip class="item" effect="dark" content="打印" placement="top">
                        <i class="el-icon-printer icons" @click="showPrintPlan"></i>
                    </el-tooltip>
                </li> -->
            </template>
            <template slot="tabs">
                <div class="page_content_center">
                    <u-table :data="dataShow" @row-click="rowClick" ref="tableRef" id="tableData"
                        :key="$store.state.tableNum" :row-height="20" :height="tableHeight" row-key="index" use-virtual
                        :big-data-checkbox="true" :highlight-current-row="false" size="mini" border>
                        <u-table-column align="center" width="90" label="序号">
                            <template slot-scope="scope">
                                {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
                            </template>
                        </u-table-column>
                        <u-table-column align="center" v-for="(tableValye, tableKey) in tableHead" :key="tableKey"
                            show-overflow-tooltip :min-width="getWidth()" :prop="tableValye" :label="tableValye"
                            :sortable="tableValye.isSort == 1 ? true : false">
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row[tableValye] }}
                                </span>
                            </template>
                        </u-table-column>
                    </u-table>
                </div>
            </template>
        </v-tabs>
        <div class="page_content_bottom">
            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
                :current-page.sync="currentPage" :page-size.sync="pageSize" :page-sizes="rpmPage"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <recordSummary ref="recordSummary"></recordSummary>
        <recordFiltering ref="recordFiltering"></recordFiltering>
    </div>
</template>

<script>
import axios from "axios"
export default {
    name: "wmsReprot",
    props: {
        reportConditionVos: {
            type: [Array],
            require: true,
            default: []
        },
        tableHead: {
            type: [Array],
            require: true,
            default: []
        },
        activeName: {
            type: [String],
            default: "报表"
        },
        type: {
            type: [String],
            default: ""
        },
    },
    data() {
        return {
            getRequestData: {//请求数据字段
                TYPE: "",
                SRQ: "",
                ERQ: "",
                MDNAME: "",//门店名称
                DJBH: "",//
                SPMCH: "",
                PIHAO: "",
                SHPCHD: "",
                LEIBIE: "",
                YHTYPE: "",
                ISPS: ""
            },
            reportModuleVos: [{ 0: this.$route.meta.title }],


            total: null,
            page: 1,
            list: [],
            AllList: [],
            // 分页数据,这里用来保存每页切割后的数据
            // 看起来格式是这样的[[{},{},{}],[{},{},{}]]
            // 数组内套数组，每个数组就是一页数据
            totalPageData: [],
            // 共几页
            pageNum: 1,
            // 每页显示数量
            pageSize: 10,
            // 当前显示页码
            currentPage: 1,
            // 总共多少条数据
            total: 1,
            // 当前要显示的数据
            dataShow: [],
            rpmPage: [10, 1000, 5000, 50000],
            tableHeight: 0,
        };
    },
    mounted() {

    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        rowClick() { },
        rowStyle({ row, rowIndex }) {
            let rowBackground = {}
            if (row.color && row.color != '') rowBackground.backgroundColor = 'red'
            return rowBackground
        },
        getWidth() { return 120 },
        openFormDesign() { },
        handleClick() { },
        handleChange() {

        },
        getPageInfo() {
            this.dataShow = []
            this.getList()
        },
        getUnixToDate(str) {
            console.log(str)
            if (str == "" || str == null) { return "" }
            var oDate = new Date(parseInt(str)),
                oYear = oDate.getFullYear(),
                oMonth = oDate.getMonth() + 1,
                oDay = oDate.getDate();

            return oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay);

        },

        getzf(n) {
            return n < 10 ? '0' + n : n;
        },
        async getList() {
            this.dataShow = []
            this.total = 0
            this.AllList = []
            let sendData = JSON.parse(JSON.stringify(this.getRequestData))
            sendData.TYPE = this.type || ""
            sendData.SRQ = this.getUnixToDate(sendData.SRQ)
            sendData.ERQ = this.getUnixToDate(sendData.ERQ)
            let res = await http(sendData)
            if (res.rowcount > 0) {
                this.AllList = res.rows
                this.list = JSON.parse(JSON.stringify(this.AllList))
                this.total = res.rows.length
                this.calcPageData();
            }

        },
        // 前端分页逻辑
        calcPageData() {
            // 计算页数(根据后台数据的条数和每页显示数量算出一共几页,得0时设为1)
            if (this.list.length > 1) {
                this.pageNum = Math.ceil(this.list.length / this.pageSize) || 1;
            }
            // 数据分组
            for (let i = 0; i < this.pageNum; i++) {
                // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                this.totalPageData[i] = this.list.slice(
                    this.pageSize * i,
                    this.pageSize * (i + 1)
                );
            }
            // 获取到数据后显示第一页内容,数组下标是从0开始的，这里一定要减去1，不然会丢失一组数据
            this.dataShow = this.totalPageData[this.currentPage - 1];
            let array = []
            for (const key in this.dataShow[0]) {
                if (this.dataShow[0].hasOwnProperty(key)) { // 确保是对象自有属性
                    array.push(key);
                }
            }

            this.tableHead = array

            console.log(this.dataShow)
            // this.fullscreenLoading = false
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.dataShow = this.totalPageData[val - 1];

        },
        // 切换显示条数
        setDataPageSize(val) {
            this.pageSize = val;
            // 重新计算页数并分组
            this.calcPageData();
        },
        // 记录汇总
        recordSummary() {
            this.numberField = []
            this.stringField = []
            let nowFieldJur = []
            this.tableHead.forEach(item => {

                nowFieldJur.push({ fieldShow: item, fieldEntity: item, isShow: 1 })
            });

            let regJE = /金额/i
            let regNum = /数量/i
            let regML = /毛利/i
            nowFieldJur.forEach((key) => {
                if (regJE.test(key.fieldEntity) || regNum.test(key.fieldEntity) || regML.test(key.fieldEntity)) {
                    this.numberField.push(key)
                    return
                }
                this.stringField.push(key)
            })
            let sendData = {
                numberField: this.numberField,
                stringField: this.stringField,
                list: this.AllList,
                rpcName: this.$route.meta.title
            }
            this.$refs.recordSummary.openBox(sendData)
        },
        // 记录过滤
        recordFiltering() {
            let nowFieldJur = []
            this.tableHead.forEach(item => {

                nowFieldJur.push({ fieldShow: item, fieldEntity: item, isShow: 1 })
            });
            let sendData = {
                nowFieldJur: nowFieldJur,
                list: this.AllList,
                rpcName: this.$route.meta.title //表格标题
            }
            this.$refs.recordFiltering.openBox(sendData)
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var obj = {}

        obj = this.$common.getSearch(this.getRequestData, 'SRQ', 'ERQ', 'page', 'rows', 30, false)

        for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
        }
        this.$nextTick(() => {
            this.getList()
            this.tableHeight = this.$common.getTableHeight()
        })


    },

    beforeCreate() {

    }, //生命周期 - 创建之前
    beforeMount() {

    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    }, //生命周期 - 更新之后
    beforeDestroy() {

    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    },
}


axios.defaults.baseURL = window.global_config.WMS_REPORT_URL
console.log(axios.defaults.headers)
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'

const http = (params) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/v1/DFPOS/GETMDDATE', params).then(res => {
            resolve(res.data)
            console.log(res.data)
            return res.data
        }).catch(error => {
            console.log(error);

            reject();
        })
    })

}
</script>
<style></style>
